import { normalize } from 'normalizr';
import { orderSchema } from './schema';
import { cloneDeep } from 'lodash';
import { get, post, patch } from '@/helpers/httpHandler';

export default {
  getOrderTransitionStatuses({ commit, dispatch }, orderId) {
    return get(`/orders/${orderId}/transition-statuses`).then(response => {
      return response;
    });
  },

  getOrderStatuses({ commit }) {
    return get('/order-statuses').then(response => {
      commit('setOrderStatuses', response.data.data);
      return response;
    });
  },

  getOrderSubstitutionOptions({ commit }) {
    return get('/orders/substitution-options').then(response => {
      commit('setSubstitutionOptions', response.data.data);
      return response;
    });
  },

  setOrders({ commit }, { orders }) {
    const { entities, result } = normalize(orders, [orderSchema]);

    commit('setEntities', entities);
    commit('setOrders', result);
  },

  addOrder({ commit }, { order }) {
    const { entities, result } = normalize(order, orderSchema);

    commit('setEntities', entities);
    commit('addOrders', [result]);
  },

  addOrders({ commit }, { orders }) {
    const { entities, result } = normalize(orders, [orderSchema]);

    commit('setEntities', entities);
    commit('addOrders', result);
  },

  getItemsList({ commit, dispatch }, { params } = {}) {
    return get(`/orders`, {
      ...params.filters,
      ...params.paginationOptions
    }).then(response => {
      commit('setFilters', cloneDeep(params.filters));
      commit('setPaginationOptions', cloneDeep(params.paginationOptions));

      dispatch('setOrders', { orders: response.data.data });

      return response;
    });
  },

  getOrdersC({ dispatch }, { personId, params }) {
    return get(`/orders-customer/person/${personId}`, params).then(response => {
      dispatch('addOrders', { orders: response.data.data });
      return response;
    });
  },

  getOrdersB({ dispatch }, { companyId, params }) {
    return get(`/orders-business/company/${companyId}`, params).then(
      response => {
        dispatch('addOrders', { orders: response.data.data });
        return response;
      }
    );
  },

  getOrdersP({ dispatch }, { companyId, params }) {
    return get(`/orders-internal/company/${companyId}`, params).then(
      response => {
        dispatch('addOrders', { orders: response.data.data });
        return response;
      }
    );
  },

  getOrder({ commit, dispatch }, { orderId }) {
    return get(`/orders/${orderId}`).then(response => {
      dispatch('addOrder', { order: response.data });
      commit('setCurrentOrder', response.data);

      return response;
    });
  },

  getOrderC({ commit, dispatch }, { orderId }) {
    return get(`/orders-customer/${orderId}`).then(response => {
      dispatch('addOrder', { order: response.data });
      commit('setCurrentOrder', response.data);

      return response;
    });
  },

  getOrderB({ commit, dispatch }, { orderId }) {
    return get(`/orders-business/${orderId}`).then(response => {
      dispatch('addOrder', { order: response.data });
      commit('setCurrentOrder', response.data);

      return response;
    });
  },

  getOrderRC({ commit, dispatch }, { orderId }) {
    return get(`/orders-repetitive/person/${orderId}`).then(response => {
      dispatch('addOrder', { order: response.data.data });
      commit('setCurrentOrder', response.data.data);

      return response.data;
    });
  },

  getOrderRB({ commit, dispatch }, { orderId }) {
    return get(`/orders-repetitive/company/${orderId}`).then(response => {
      dispatch('addOrder', { order: response.data.data });
      commit('setCurrentOrder', response.data.data);

      return response.data;
    });
  },

  getOrderP({ commit, dispatch }, { orderId }) {
    return get(`/orders-internal/${orderId}`).then(response => {
      dispatch('addOrder', { order: response.data });
      commit('setCurrentOrder', response.data);

      return response;
    });
  },

  getWorkProfile(_, { companyId }) {
    return get(`/orders/work-profiles/${companyId}`);
  },

  getOrderTasksList(_, { orderId }) {
    return get(`/planning/tasks-of-order/${orderId}`);
  },

  getFilteredOrderNumbers(_, params) {
    return get(`/orders/filters/order-number`, params);
  },
  getFilteredSources(_, params) {
    return get(`/orders/filters/source`, params);
  },
  getFilteredCustomers(_, params) {
    return get(`/orders/filters/customer`, params);
  },

  storeOrderC: ({ dispatch }, { order }) => {
    return post(`/orders-customer`, order).then(response => {
      dispatch('addOrder', { order: response.data });

      return response;
    });
  },

  storeOrderB: ({ dispatch }, { order }) => {
    return post(`/orders-business`, order).then(response => {
      dispatch('addOrder', { order: response.data });

      return response;
    });
  },

  storeOrderRC: ({ dispatch }, { personId, order }) => {
    return post(`/orders-repetitive/person/${personId}`, order).then(
      response => {
        dispatch('addOrder', { order: response.data });

        return response;
      }
    );
  },

  storeOrderRB: ({ dispatch }, { companyId, order }) => {
    return post(`/orders-repetitive/company/${companyId}`, order).then(
      response => {
        dispatch('addOrder', { order: response.data });

        return response;
      }
    );
  },

  storeOrderP: ({ dispatch }, { order }) => {
    return post(`/orders-internal`, order).then(response => {
      dispatch('addOrder', { order: response.data });

      return response;
    });
  },

  updateOrderC: ({ dispatch }, { orderId, order }) => {
    return patch(`/orders-customer/${orderId}`, order).then(response => {
      dispatch('addOrder', { order: response.data });

      return response;
    });
  },

  updateOrderB: ({ dispatch }, { orderId, order }) => {
    return patch(`/orders-business/${orderId}`, order).then(response => {
      dispatch('addOrder', { order: response.data });

      return response;
    });
  },

  updateOrderRC: ({ dispatch }, { orderId, order }) => {
    return patch(`/orders-repetitive/person/${orderId}`, order).then(
      response => {
        dispatch('addOrder', { order: response.data });

        return response;
      }
    );
  },

  updateOrderRB: ({ dispatch }, { orderId, order }) => {
    return patch(`/orders-repetitive/company/${orderId}`, order).then(
      response => {
        dispatch('addOrder', { order: response.data });

        return response;
      }
    );
  },

  updateOrderP: ({ dispatch }, { orderId, order }) => {
    return patch(`/orders-internal/${orderId}`, order).then(response => {
      dispatch('addOrder', { order: response.data });

      return response;
    });
  }
};
